/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputChatMessageUser } from './OutputChatMessageUser';
import {
    OutputChatMessageUserFromJSON,
    OutputChatMessageUserFromJSONTyped,
    OutputChatMessageUserToJSON,
} from './OutputChatMessageUser';

/**
 * 
 * @export
 * @interface OutputChatReaction
 */
export interface OutputChatReaction {
    /**
     * 
     * @type {number}
     * @memberof OutputChatReaction
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OutputChatReaction
     */
    reaction: string;
    /**
     * 
     * @type {OutputChatMessageUser}
     * @memberof OutputChatReaction
     */
    user: OutputChatMessageUser;
}

/**
 * Check if a given object implements the OutputChatReaction interface.
 */
export function instanceOfOutputChatReaction(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('reaction' in value)) return false;
    if (!('user' in value)) return false;
    return true;
}

export function OutputChatReactionFromJSON(json: any): OutputChatReaction {
    return OutputChatReactionFromJSONTyped(json, false);
}

export function OutputChatReactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputChatReaction {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'reaction': json['reaction'],
        'user': OutputChatMessageUserFromJSON(json['user']),
    };
}

export function OutputChatReactionToJSON(value?: OutputChatReaction | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'reaction': value['reaction'],
        'user': OutputChatMessageUserToJSON(value['user']),
    };
}

